var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class SportsBaseRetriever {
    constructor(connections, sportsMapper, pushesRetriever, refreshInterval) {
        this.connections = connections;
        this.sportsMapper = sportsMapper;
        this.pushesRetriever = pushesRetriever;
        this.refreshInterval = refreshInterval;
        this.sportRefreshTimer = -1;
        this.isActive = false;
        this.connection = this.connections.filterSports();
    }
    activate() {
        this.isActive = true;
    }
    refresh(state, request, sportApiQueryFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            clearTimeout(this.sportRefreshTimer);
            return this.refreshInternal(state, request, sportApiQueryFactory);
        });
    }
    refreshInternal(state, request, sportApiQueryFactory) {
        return __awaiter(this, void 0, void 0, function* () {
            this.pushesRetriever.unsubscribe();
            const response = yield this.getSports(request);
            if (this.isActive && response.sports) {
                this.setSports(state, response.sports, sportApiQueryFactory);
                if (this.refreshInterval > 0) {
                    this.sportRefreshTimer = window.setTimeout(() => this.refreshInternal(state, request, sportApiQueryFactory), this.refreshInterval);
                }
            }
        });
    }
    getSports(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield new Promise((resolve, reject) => {
                    this.connection.loadData(request, resolve, reject);
                });
            }
            catch (_a) {
                return { sports: [] };
            }
        });
    }
    setSports(state, sports, sportApiQueryFactory) {
        if (sports && sports.length > 0) {
            const notSports = state.Items.filter(x => x.type !== "sports");
            const newSports = this.sportsMapper.map(sports);
            const newItems = notSports.concat(newSports);
            state.replaceItems(newItems);
            this.pushesRetriever.subscribe(state, sportApiQueryFactory);
        }
    }
    deactivate() {
        this.isActive = false;
        clearTimeout(this.sportRefreshTimer);
        this.pushesRetriever.unsubscribe();
        this.connection.deactivate();
    }
}
//# sourceMappingURL=SportsBaseRetriever.js.map